



























import { Component, Vue } from "vue-property-decorator";
import SimpleTable from "@/basics/table/SimpleTable.vue";
import NoData from "@/basics/boxes/NoData.vue";
import { ALL_APP_USERS, AllAppUserData } from "@/graphql/query/appUser/all";
import formatDate from "@/lib/formatDate";

export interface AppUser {
  id: string;
  name: string;
  start: string;
  end: string;
  createdAt: string;
  expired: boolean;
  prePeriod: boolean;   
}

@Component({
  components: { SimpleTable, NoData },
  apollo: {
    appUsers: {
      query: ALL_APP_USERS,
      update(data: AllAppUserData): AppUser[] {
        return data.appUserFeed.appUsers.map(a => ({
          ...a,
          start: formatDate(new Date(a.start)),
          end: formatDate(new Date(a.end)),
          createdAt: formatDate(new Date(a.createdAt))
        }));
      }
    }
  }
})
export default class AppAccountsList extends Vue {
  appUsers!: AppUser[];
}
